export default __webpack_public_path__ + "static/media/6Z0A6780 2.7f5c38f6.jpg";